(function () {
  'use strict';

  var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var API_URL = 'https://checkout.api.circuly.io/v1/online-resellers/qKpqcIU33sRxNU79e4E264BLq7k968/generate-visual';

  function wrapButtonWords(container) {
    // The roll-up animation only ever runs under that same media query (see
    // _academy-product-card.scss), so skip restructuring the text on
    // touch/mobile — it just risks the button's fixed height clipping the
    // text-shadow duplicate line for no visual benefit.
    if (!supportsHover) return;

    var btn = container.querySelector('.rent-now-button');
    if (!btn || btn.dataset.wordsWrapped) return;

    var words = btn.textContent.trim().split(/\s+/).filter(Boolean);
    if (!words.length) return;

    btn.textContent = '';
    words.forEach(function (word, index) {
      var wordSpan = document.createElement('span');
      wordSpan.className = 'rent-now-button__word';
      var inner = document.createElement('span');
      inner.className = 'rent-now-button__word-inner';
      inner.style.transitionDelay = index * 0.04 + 's';
      inner.textContent = word;
      wordSpan.appendChild(inner);
      btn.appendChild(wordSpan);
    });
    btn.dataset.wordsWrapped = 'true';
  }

  function runRecalculateLayouts() {
    // Content is injected asynchronously, so any layout that measured heights
    // on load (e.g. the Flickity slideshow) needs a nudge to recalc.
    window.dispatchEvent(new Event('resize'));
    document.querySelectorAll('slide-show').forEach(function (slideShow) {
      if (slideShow.flickity && typeof slideShow.flickity.resize === 'function') {
        slideShow.flickity.resize();
      }
    });
  }

  // One fetch fires per unique barcode, and each one calls this on resolve
  // (success or failure). On a page with many Bike Club cards that used to
  // dispatch a burst of synchronous `resize` events back-to-back during page
  // load — every resize listener on the page (hero tiles, parallax scroll,
  // GSAP ScrollTrigger, …) ran on each one, saturating the main thread and
  // stuttering the hero background video. Collapse the burst into a single
  // trailing call.
  var recalcTimer = null;
  function recalculateLayouts() {
    if (recalcTimer) clearTimeout(recalcTimer);
    recalcTimer = setTimeout(function () {
      recalcTimer = null;
      runRecalculateLayouts();
    }, 150);
  }

  // ── Bike Club product form (snippets/bike-club-product-form.liquid) ──────
  // The form wraps the Circuly container in a [data-acbf] root and wants the
  // price + rent link lifted into its own markup. If that can't be done it
  // falls back to showing Circuly's own widget so there is always a working
  // rent button.

  function bikeClubRoot(container) {
    return container && container.closest ? container.closest('[data-acbf]') : null;
  }

  function extractRentalPrice(container) {
    var el = container.querySelector('.rental-price') || container.querySelector('[class*="price"]');
    if (el && el.textContent.trim()) return el.textContent.trim();
    var m = (container.textContent || '').match(/€\s*[\d.,]+|[\d.,]+\s*€/);
    return m ? m[0].trim() : '';
  }

  function extractRentalHref(container) {
    var a = container.querySelector('a.rent-now-button[href], .rent-now-button a[href], a[href*="circuly"], a[href]');
    return a ? a.getAttribute('href') : '';
  }

  // Splits `text` into `<span class="{wordClass}"><span class="{innerClass}">
  // word</span></span>` groups (staggered via transitionDelay), replacing
  // `el`'s current content. Shared by the main-price Upgrade reveal and the
  // Bike Club CTA's word-roll hover.
  function setWordSpans(el, text, wordClass, innerClass) {
    el.textContent = '';
    text.split(/\s+/).filter(Boolean).forEach(function (word, index) {
      if (index > 0) el.appendChild(document.createTextNode(' '));
      var wordSpan = document.createElement('span');
      wordSpan.className = wordClass;
      var inner = document.createElement('span');
      inner.className = innerClass;
      inner.style.transitionDelay = index * 0.04 + 's';
      inner.textContent = word;
      wordSpan.appendChild(inner);
      el.appendChild(wordSpan);
    });
  }

  // Replaces the [data-acbf-mainprice] skeleton with the real rent price.
  // Form 1 ("Standard") fades the swap in; Form 2 ("Upgrade") gets the
  // word-roll reveal (see .academy-price-skeleton in _academy-product.scss).
  function setMainPrice(price) {
    if (!price) return;
    var value = /^\s*ab\b/i.test(price) ? price : 'ab ' + price;
    document.querySelectorAll('[data-acbf-mainprice]').forEach(function (el) {
      // Word-roll is a one-shot reveal fired on load, not a hover effect —
      // unlike wrapButtonWords()/the CTA word-roll, it runs on every device.
      var isUpgrade = el.classList.contains('academy-price-skeleton--upgrade');
      if (isUpgrade) {
        setWordSpans(el, value, 'academy-price-skeleton__word', 'academy-price-skeleton__word-inner');
        // Words start translateY(100%) (see CSS); flip to revealed a frame
        // later so the transition actually plays instead of snapping in.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            el.querySelectorAll('.academy-price-skeleton__word-inner').forEach(function (word) {
              word.classList.add('is-revealed');
            });
          });
        });
      } else {
        el.classList.add('is-swapping');
        el.textContent = value;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            el.classList.remove('is-swapping');
          });
        });
      }
    });
  }

  // Stops the main-price skeleton shimmer when no price will ever arrive
  // (fetch failure / unavailable barcode) and shows a plain "not available"
  // message instead of leaving the big price spot blank.
  function clearMainPriceSkeleton() {
    document.querySelectorAll('[data-acbf-mainprice]').forEach(function (el) {
      el.classList.remove('academy-price-skeleton--upgrade');
      el.classList.add('academy-price-skeleton--unavailable');
      el.textContent = 'Aktuell nicht verfügbar';
    });
  }

  function bikeClubFallback(root, container) {
    // Show Circuly's own widget inside the card; drop our placeholders.
    if (container) {
      container.removeAttribute('hidden');
      setMainPrice(extractRentalPrice(container));
    }
    if (!root) return;
    root.classList.add('bike-club-form--fallback');
    var cta = root.querySelector('[data-acbf-cta]');
    if (cta) cta.hidden = true;
    var pending = root.querySelector('[data-acbf-pending]');
    if (pending) pending.remove();
    if (supportsHover && container) wrapButtonWords(container);
  }

  function hydrateBikeClubForm(container) {
    var root = bikeClubRoot(container);
    if (!root) return;

    var price = extractRentalPrice(container);
    var href = extractRentalHref(container);

    if (!href) {
      console.warn('[bike-club-form] no rent link in Circuly response — showing raw widget', container.innerHTML.slice(0, 200));
      bikeClubFallback(root, container);
      return;
    }

    var prefix = root.dataset.ctaPrefix || 'Jetzt für [preis] mieten';
    var label = price
      ? prefix.replace('[preis]', price)
      : prefix.replace('[preis]', '').replace(/\s{2,}/g, ' ').trim();

    var cta = root.querySelector('[data-acbf-cta]');
    if (cta) {
      cta.setAttribute('href', href);
      var rentLink = container.querySelector('a[href]');
      if (rentLink && rentLink.target) cta.target = rentLink.target;
      var textEl = cta.querySelector('[data-acbf-cta-text]') || cta;
      // Upgrade button style (invert hover + word-roll) applies to both
      // Bike Club forms — see .bike-club-form__cta-word in
      // _bike-club-product-form.scss.
      if (supportsHover) {
        setWordSpans(textEl, label, 'bike-club-form__cta-word', 'bike-club-form__cta-word-inner');
      } else {
        textEl.textContent = label;
      }
      cta.hidden = false;
    }

    var priceOut = root.querySelector('[data-acbf-price]');
    if (priceOut && price) {
      priceOut.textContent = 'ab ' + price;
      priceOut.hidden = false;
    }

    // Also swap the big product price (title block) for the rent price.
    setMainPrice(price);

    var pending = root.querySelector('[data-acbf-pending]');
    if (pending) pending.remove();
    root.classList.add('bike-club-form--hydrated');
  }

  function markUnavailable(container) {
    var root = bikeClubRoot(container);
    if (root) {
      var pending = root.querySelector('[data-acbf-pending]');
      if (pending) pending.textContent = 'Aktuell nicht verfügbar';
      var cta = root.querySelector('[data-acbf-cta]');
      if (cta) cta.hidden = true;
    }
    clearMainPriceSkeleton();
    container.remove();
  }

  // ── Scan + fetch ───────────────────────────────────────────────────────
  function processContainers(scopeEl) {
    var scope = scopeEl && scopeEl.querySelectorAll ? scopeEl : document;
    var containers = Array.prototype.slice
      .call(scope.querySelectorAll('.rental-info-container, .rental-info-container-sticky'))
      .filter(function (c) { return !c.dataset.rentalProcessed; });
    if (!containers.length) return;
    containers.forEach(function (c) { c.dataset.rentalProcessed = '1'; });

    var groups = new Map();
    containers.forEach(function (container) {
      var barcode = container.dataset.barcode;
      if (!barcode) {
        markUnavailable(container);
        return;
      }
      if (!groups.has(barcode)) groups.set(barcode, []);
      groups.get(barcode).push(container);
    });

    groups.forEach(function (elements, barcode) {
      var reference = elements[0];
      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          barcode: barcode,
          locale: reference.dataset.locale || 'de',
          source: reference.dataset.source || 'academy',
          custom_params: reference.dataset.customParams || 'view=academy'
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP error! Status: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (!html.trim()) {
            elements.forEach(function (el) {
              if (bikeClubRoot(el)) markUnavailable(el);
              else el.remove();
            });
            recalculateLayouts();
            return;
          }
          elements.forEach(function (el) {
            el.innerHTML = html;
            if (bikeClubRoot(el)) {
              hydrateBikeClubForm(el);
            } else {
              if (el.closest('.product-card--bikeclub-button-wrapper--upgrade')) wrapButtonWords(el);
            }
          });
          recalculateLayouts();
        })
        .catch(function (error) {
          // Circuly's generate-visual endpoint currently 404s for some
          // barcodes. Keep it to one concise warning per barcode instead
          // of a full error+stack per card, and hide the container rather
          // than removing it — the layout stays put and the theme editor
          // can still re-hydrate it on the next shopify:section:load.
          console.warn('[rent-a-bikeclub] rental info unavailable for barcode ' + barcode + ' (' + error.message + ')');
          elements.forEach(function (el) {
            var root = bikeClubRoot(el);
            if (root) {
              var pending = root.querySelector('[data-acbf-pending]');
              if (pending) pending.textContent = 'Aktuell nicht verfügbar';
              var cta = root.querySelector('[data-acbf-cta]');
              if (cta) cta.hidden = true;
            }
            el.hidden = true;
          });
          clearMainPriceSkeleton();
          recalculateLayouts();
        });
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () { processContainers(document); });
  // Shopify theme editor re-renders the section on every block add/remove/edit.
  document.addEventListener('shopify:section:load', function (event) {
    processContainers(event.target);
  });
  // Facet filtering (facets.js) replaces #ProductGridContainer's innerHTML,
  // and load-more/infinite pagination (pagination.js) appends fresh cards —
  // both insert brand-new, unprocessed rental-info-container elements.
  document.addEventListener('academy:product-grid:updated', function () {
    processContainers(document);
  });
})();
